import { KeyboardDatePicker, KeyboardDatePickerProps } from '@material-ui/pickers';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DatePicker: React.FC<KeyboardDatePickerProps> = props => {
  const { t } = useTranslation();

  return (
    <KeyboardDatePicker
      autoOk
      inputVariant="outlined"
      variant="inline"
      format="dd/MM/yyyy"
      disableFuture={true}
      mask="__/__/____"
      disableToolbar
      invalidDateMessage={t('customInputs.datepicker.invalidMessage')}
      {...props}
    />
  );
};

export default DatePicker;
